// noinspection JSUnresolvedVariable (scheduler i toastr - czy one są jakoś definiowane, czy to błędny kod?)
class ApiScheduler {
    static init(schedulerId, config) {
        settings = ApiScheduler.settingsBuilder(schedulerId, config);
        if (settings.methodSaveForm === 'POST') {
            ApiScheduler.buildHiddenForm();
        }
        ApiScheduler.buildCalendar();
        ApiScheduler.initScheduler();
        ApiScheduler.bindSaveButton();
        ApiScheduler.lockExit();
    }

    /**
     * Funkcja sprawdza czy przycisk jest ustawiony jeżeli nie to nadaje mu wartość true
     * @param {bool} button wartość bool dla przycisku z konfiguracji
     * @returns {*}
     */
    static isConfigButtonSet(button) {
        let value;
        if (typeof (button) === 'undefined') {
            value = true;
        } else {
            value = button;
        }
        return value;
    }

    /**
     * Budowanie ustawień na podstawie przekazanej konfiguracji
     * @param  {string} schedulerId ID obiektu kalendarza
     * @param  {json} config        Konfiguracja kalendarza
     * @return {json}               konfiguracja funkcji
     */
    static settingsBuilder(schedulerId, config) {
        let yearView, monthView, weekView, dayView, today;

        if (typeof config !== 'object') {
            throw new Error('Konfiguracja powinna być obiektem JSON');
        }

        if (!config.hasOwnProperty('dataUrl') || typeof config.dataUrl === 'undefined') {
            throw new Error('W obiekcie konfiguracji nie zdefiniowano pola `dataUrl`');
        }

        if (config.hasOwnProperty('navLine') && typeof config.navLine !== 'undefined') {
            // noinspection JSUnresolvedVariable
            today = ApiScheduler.isConfigButtonSet(config.navLine.todayButton);
            // noinspection JSUnresolvedVariable
            dayView = ApiScheduler.isConfigButtonSet(config.navLine.dayViewButton);
            // noinspection JSUnresolvedVariable
            weekView = ApiScheduler.isConfigButtonSet(config.navLine.weekViewButton);
            // noinspection JSUnresolvedVariable
            monthView = ApiScheduler.isConfigButtonSet(config.navLine.monthViewButton);
            // noinspection JSUnresolvedVariable
            yearView = ApiScheduler.isConfigButtonSet(config.navLine.yearViewButton);
        } else {
            today = dayView = weekView = monthView = yearView = true;
        }

        let lockExit;
        if (config.hasOwnProperty('lockExit') && typeof (config.lockExit) !== 'undefined') {
            lockExit = config.lockExit;
        } else {
            lockExit = false;
        }

        const formAction = $('#' + schedulerId).attr('formAction');

        const todayButton = today ? '<div class="dhx_cal_today_button"></div>' : '';
        const dayButton = dayView ? "<div class=\"dhx_cal_tab\" name=\"day_tab\"></div>" : '';
        const weekButton = weekView ? "<div class=\"dhx_cal_tab\" name=\"week_tab\"></div>" : '';
        const monthButton = monthView ? "<div class=\"dhx_cal_tab\" name=\"month_tab\"></div>" : '';
        const yearButton = yearView ? "<div class=\"dhx_cal_tab\" name=\"year_tab\"></div>" : '';

        return {
            "buttonsCode": {
                "today": todayButton,
                "dayView": dayButton,
                "weekView": weekButton,
                "monthView": monthButton,
                "yearView": yearButton,
            },
            "classes": {
                "saveButton": ".btn-save"
            },
            'texts': {
                "lockExit": "Nie zapisałeś zmian."
            },
            "hiddenForm": {
                "formID": "hiddenFormToSave",
                "formAction": formAction,
                "iframeID": "hidden_frame",
                "urlID": "hiddenUrlInputToSave",
                "dataID": "hiddenDataInputToSave"
            },
            "lockExit": lockExit,
            "dataUrl": config.dataUrl,
            "schedulerId": schedulerId,
            "methodSaveForm": "Ajax" //POST
        }
    }

    /**
     * Tworzenie struktury kalendarza na podstawie danych podanych w konfiguracji w blocku navLine
     */
    static buildCalendar() {
        let classNav = '';

        if (settings.buttonsCode.save) {
            classNav = settings.classes.saveButton;
        }

        const navLine = '<div class="dhx_cal_navline ' + classNav + '">' +
            '<div class="dhx_cal_prev_button">&nbsp;</div>' +
            '<div class="dhx_cal_next_button">&nbsp;</div>' +
            settings.buttonsCode.today +
            '<div class="dhx_cal_date"></div>' +
            settings.buttonsCode.dayView +
            settings.buttonsCode.weekView +
            settings.buttonsCode.monthView +
            settings.buttonsCode.yearView +
            '</div>';
        const header = '<div class="dhx_cal_header"></div>';
        const calendar = '<div class="dhx_cal_data"></div>';

        $('#' + settings.schedulerId).prepend(navLine)
            .prepend(header)
            .prepend(calendar);
    }

    /**
     * Budowanie ukrytego formularza i iframe w celu zapisywania kalendarza przez wysyłanie go formularzem.
     * Stworzenie tych elementów pozwala wysłać formularz bez przeładowania strony.
     */
    static buildHiddenForm() {
        //Tworzenie formularza
        const form = document.createElement('form');
        form.method = 'post';
        form.action = settings.hiddenForm.formAction;
        form.target = settings.hiddenForm.iframeID;
        form.id = settings.hiddenForm.formID;

        const iframe = document.createElement('iframe');
        iframe.src = 'auto:blank';
        iframe.width = 0;
        iframe.height = 0;
        iframe.id = settings.hiddenForm.iframeID;
        iframe.name = settings.hiddenForm.iframeID;

        const data = document.createElement("input"); //input element, text
        data.type = 'hidden';
        data.name = 'data';
        data.id = settings.hiddenForm.dataID;

        const url = document.createElement("input"); //input element, text
        url.type = 'hidden';
        url.name = 'url';
        url.id = settings.hiddenForm.urlID;

        form.appendChild(data);
        form.appendChild(url);

        document.body.appendChild(form);
        document.body.appendChild(iframe);
    }

    /**
     * Inicjalizacja kalendarza DHTMLXa wraz z załadowaniem danych z linka podanego w konfiguracji
     */
    static initScheduler() {
        const $scheduler = $('#' + settings.schedulerId);
        if ($scheduler.length) {
            $scheduler.addClass('dhx_cal_container');

            if (typeof scheduler !== 'undefined') {
                scheduler.init(settings.schedulerId, new Date(), "month");
                scheduler.load(settings.dataUrl, 'json');
            }
        }
    }

    /**
     * Podłączenie funkcji zapisywania JSON-a do pliku, którego ścieżka jest podana w konfiguracji.
     * Dane są zapisywane za pomocą pliku PHP, do którego adres jest podawany w form.action
     */
    static bindSaveButton() {
        $(settings.classes.saveButton).on('click', function (e) {
            e.preventDefault();

            if (settings.methodSaveForm === 'POST') {
                if (typeof scheduler !== 'undefined') {
                    $('#' + settings.hiddenForm.dataID).val(scheduler.toJSON());
                }

                $('#' + settings.hiddenForm.urlID).val(settings.dataUrl);

                $('#' + settings.hiddenForm.formID).submit();
            } else if (settings.methodSaveForm === 'Ajax') {
                if (typeof scheduler !== 'undefined') {
                    $.ajax({
                        url: settings.hiddenForm.formAction,
                        dataType: 'json',
                        method: "POST",
                        data: {
                            "data": scheduler.toJSON(),
                            "url": settings.dataUrl
                        }
                    }).always(function (data) {
                        if (typeof toastr !== 'undefined') {
                            toastr.info(data.responseText);
                        }
                    });
                }
            }
        });
    }

    /**
     * Funkcja sprawdzająca czy są różnice pomiędzy kalendarzem, a wartościami podanymi w pliku.
     * Porównywane są dwa JSONy.
     */
    static lockExit() {
        if (settings.lockExit) {
            const exitText = settings.texts.lockExit;
            $(window).on('beforeunload ', function () {
                let file = $.ajax({
                    url: settings.dataUrl,
                    async: false
                });
                file = JSON.stringify(file.responseText);
                file = file.replace(/(?:\\[r])+/g, "");
                const actual = JSON.stringify(scheduler.toJSON());
                if (file !== actual) {
                    return exitText;
                }
            });
        }
    }
}
